import { render } from "./readClubPage.vue?vue&type=template&id=b28be9f2&scoped=true"
import script from "./readClubPage.vue?vue&type=script&lang=js"
export * from "./readClubPage.vue?vue&type=script&lang=js"

import "./readClubPage.vue?vue&type=style&index=0&id=b28be9f2&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b28be9f2"]])

export default __exports__